export function deepEqual(obj1: any, obj2: any): boolean {
  // Wenn beide Objekte gleich sind (auch null oder undefined)
  if (obj1 === obj2) return true;
  // Wenn einer der beiden Werte null oder undefined ist oder die Typen nicht übereinstimmen
  if (obj1 == null || obj2 == null || typeof obj1 !== typeof obj2) return false;
  // Wenn die Objekte keine Objekte sind (z.B. primitive Werte)
  if (typeof obj1 !== "object" || typeof obj2 !== "object") return false;
  // Überprüfe, ob die beiden Objekte dieselbe Anzahl an Schlüsseln haben
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  // Vergleiche die Werte der beiden Objekte rekursiv
  for (const key of keys1) {
    // Überprüfe rekursiv, ob die Werte gleich sind
    if (!deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
}
